export default {
  // 获取不正常航班证明详情
  async getCertifyInfoList(params, type) {
    let actiontype = "phoneAbnormalFlightService_AbnormalDetrTNHandler";
    return await this.fetch(actiontype, params, type);
  },
  //下载不正常航班证明
  async getAbnormalFlightReport(params) {
    let actiontype = "getAbnormalFlightReport";
    return await this.fetch(actiontype, params);
  },
  //发送至邮箱
  async sendAbnormalFlightReportEmail(params) {
    let actiontype = "sendAbnormalFlightReportEmail";
    return await this.fetch(actiontype, params);
  }
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/wrongFlightCertify.js